import { Action, createReducer, on } from '@ngrx/store';

import { KnowledgeBaseAction } from './knowledge-base.dispatcher';
import { initialKnowledgeBase, KnowledgeBase } from './knowledge-base.model';

const knowledgeBaseReducer = createReducer(
  initialKnowledgeBase,
  on(KnowledgeBaseAction.SuggestedResults, (state, { suggestedResults }) => ({
    ...state,
    suggestedResults,
  })),
  on(KnowledgeBaseAction.SearchResults, (state, { searchResults }) => ({
    ...state,
    searchResults,
  }))
);

export function reducer(state: KnowledgeBase | undefined, action: Action) {
  return knowledgeBaseReducer(state, action);
}
